import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface PostCategoriesQueryObject {
  postCategories: {
    items: {
      id: boolean
      name: boolean
      category_blog_image: boolean
      category_blog_thumbnail: boolean
      url_key: boolean
      meta_title: boolean
      meta_tags: boolean
      meta_description: boolean
    }
  }
}

export const postCategoriesQueryObject: PostCategoriesQueryObject = {
  postCategories: {
    items: {
      id: true,
      name: true,
      category_blog_image: true,
      category_blog_thumbnail: true,
      url_key: true,
      meta_title: true,
      meta_tags: true,
      meta_description: true
    }
  }
}

export type PostCategoriesQuery = () => Promise<ApolloQueryResult<any>>

export const createPostCategoriesQuery = ({ getQueries }: ServiceDependencies): PostCategoriesQuery => async () => {
  const query = getQueries().postCategoriesQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`
  })
}
